
import DeleteIcon from '@mui/icons-material/Delete';
import { IconButton, lighten, Theme, Toolbar, Tooltip, Typography } from '@mui/material';
import classNames from "classnames";
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import * as actions from '../../../../store/actions/index';
import { AppState } from '../../../../store/rootReducer';
//
const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        paddingRight: theme.spacing(1),
        
    },
    highlight:
        theme.palette.primary.light === "light"
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85)
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper
            },
    spacer: {
        flex: "1 1 100%"
    },
    actions: {
        color: theme.palette.text.secondary
    },
    title: {
        flex: "0 0 auto"
    },
}));
//
const UserListTableToolbar = (/* props*/) => {
    const dispatch = useDispatch();
    const { classes } = useStyles();
    const selectedUserList = useSelector(state => (state as AppState).userAdmin.selectedUserList);
    const setUserDeletionState = () => dispatch(actions.setUserDeletionState(1));
    const user: any = useSelector((state) => (state as AppState).auth.userJWT);
    //
    useEffect(() => {
        dispatch(actions.setLocationPath(<>Brukeradministrasjon {'>'} Brukerliste for {user?.company?.toString()}</>));
    }, [dispatch]);
    //
    return (
        <Toolbar className={classNames(classes.root, { [classes.highlight]: selectedUserList.length > 0 })}>
            <div className={classes.title}>
                {selectedUserList.length > 0 ? (
                    <Typography>
                        {selectedUserList.length} selected
                    </Typography>
                ) : (
                    null
                )}
            </div>
            <div className={classes.spacer} />
            <div className={classes.actions}>
                {selectedUserList.length > 0 ? (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete" onClick={() => setUserDeletionState()}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                ) : null}
            </div>
        </Toolbar>
    );
};

export default UserListTableToolbar;
